import { render, staticRenderFns } from "./LangSwitcherDropdown.vue?vue&type=template&id=2fdc03b8&scoped=true&lang=pug&"
import script from "./LangSwitcherDropdown.vue?vue&type=script&lang=js&"
export * from "./LangSwitcherDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LangSwitcherDropdown.vue?vue&type=style&index=0&id=2fdc03b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc03b8",
  null
  
)

export default component.exports